<template>
    <WarningEmail v-if="errorRange"/>
    <WarningPassword v-if="errorPassword"/>
    <div class="container-form">
        <form class="reset-password-form">
            <legend>Recuperar contraseña</legend>
            <div class="col-sm-9 col-md-9 col-ls-9">
                <label class="label-form">Correo Electrónico</label>
                <input class="input-form" v-model="email" type="text"/>
            </div>
            <button class="button-save" @click.prevent="ChangeView()">Enviar</button>
        </form>
    </div>
</template>

<script>
import router from '../../router';
import { mapActions, mapState } from 'vuex';
import WarningEmail from '../Warning/WarningEmail.vue';
import WarningPassword from '../Warning/WarningPassword.vue';
export default {
    name: 'PasswordResetEmail',
    computed: {
        ...mapState(['errorRange', 'errorPassword'])
    },
    methods: {
        ...mapActions(['requestPasswordReset']),
        async ChangeView(){
            try {
                await this.requestPasswordReset({email: this.email})
                router.push('/PasswordReset')
            } catch (error) {
                console.log(error)
            }
        }
    },
    components: {
        WarningEmail,
        WarningPassword
    }
}
</script>
<style scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vh;
}
.reset-password-form {
    width: 30rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-bottom: -1px;
}
.label-form {
    font-size: 1.1rem;
    padding: .4rem 0rem 0rem 2rem;
}
.input-form {
    margin: 0.5rem 0rem .5rem 2rem;
    height: 2.4rem;
    width: 25rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding: 1rem;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.6rem;
    padding: .3rem 0rem .3rem 2rem;
}
.button-save {
    width: 6rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: .5rem 0rem .8rem 2rem;
}
p {
    padding: 0rem 3.5rem .3rem 2rem;
    font-size: .95rem;
    color: rgb(84, 104, 5);
    font-weight: bold;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
@media (max-width: 769px) {
    .reset-password-form,
    .button-save,
    .input-form {
    max-width: 80% !important;
  }
 }
</style>